module.exports = __webpack_public_path__ + "static/media/lundagard.beefa5e4.png";